import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import css from './link.css';

const Link = ({ children, className, ...otherProps }) => (
  <a className={classnames([css['ds-card-link'], className])} {...otherProps}>
    {children}
  </a>
);

Link.defaultProps = {
  children: null,
  className: '',
};
Link.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
};

export default Link;
